"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconTheme = void 0;
var _colors = require("../colors");
var IconTheme = exports.IconTheme = {
  "default": {
    color: _colors.FullPalette.EVERGREEN_700
  },
  colors: {
    aiMagic: _colors.FullPalette.VIOLET_600
  }
};